import { getAnalytics, logEvent as firebaseLogEvent } from 'firebase/analytics';

const CONSENT_KEY = 'cookieConsent';

let analyticsInstance = null;

export function getConsentChoice() {
  return localStorage.getItem(CONSENT_KEY); // 'accepted' | 'declined' | null (not yet decided)
}

export function hasAnalyticsConsent() {
  return getConsentChoice() === 'accepted';
}

function ensureAnalytics() {
  if (!hasAnalyticsConsent()) return null;
  if (!analyticsInstance) {
    analyticsInstance = getAnalytics();
  }
  return analyticsInstance;
}

// Only actually loads/calls Firebase Analytics (and its gtag.js network request)
// once the visitor has accepted cookies — never fires on page load by default.
export function logAnalyticsEvent(eventName, params) {
  const analytics = ensureAnalytics();
  if (analytics) firebaseLogEvent(analytics, eventName, params);
}

export function acceptAnalyticsConsent() {
  localStorage.setItem(CONSENT_KEY, 'accepted');
  ensureAnalytics();
}

export function declineAnalyticsConsent() {
  localStorage.setItem(CONSENT_KEY, 'declined');
  analyticsInstance = null;
}
